<script>
	import Tailwindcss from './Tailwindcss.svelte';
    import { onMount } from "svelte"

    let lastSave = 0
    let timers = []
    let activeTimers = []
    let colors = ["#0ea5e9", "#22c55e", "#f97316", "#71717a", "#a855f7", "#f43f5e"]

    function addTimer() {
        timers = [...timers, {
            name: "New timer",
            color: colors[Math.round(Math.random() * (colors.length - 1))],
            timer: 0,
        }]
        save()
    }
    function renameTimer(index, newName) {
        timers = timers.map((timer, i) => {
            if(index === i) timer.name = newName
            return timer
        })
        save()
    }
    function startTimer(index) {
        if(!activeTimers.includes(index)) activeTimers = [...activeTimers, index]
    }
    function stopTimer(index) {
        activeTimers = activeTimers.filter(i => i !== index)
    }
    function resetTimer(index) {
        timers = timers.map((timer, i) => {
            if(index === i) timer.timer = 0
            return timer
        })
        save()
    }
    function deleteTimer(index) {
        timers = timers.filter((timer, i) => i !== index)
        save()
    }
    function swapColor(index) {
        const currentIndex = colors.findIndex(e => timers[index].color === e)
        const newColorIndex = currentIndex + 1 >= colors.length ? 0 : currentIndex + 1
        timers = timers.map((timer, i) => {
            if(i === index) timer.color = colors[newColorIndex]
            return timer
        })
    }

    function save() {
        localStorage.setItem("lstt_data", JSON.stringify(timers)) // Linus Simple Time Tracking
        lastSave = new Date().getTime()
    }

    onMount(() => {
        if(localStorage.getItem("lstt_data")) {
            try {
                timers = JSON.parse(localStorage.getItem("lstt_data"))
            }catch(error) {
                console.error(error)
                console.log("Failed to load data")
            }
        }
        setInterval(() => {
            activeTimers.forEach(activeTimer => {
                timers = timers.map((timer, index) => {
                    if(index === activeTimer) timer.timer++
                    return timer
                })
            })
            if(new Date().getTime() + 1000 * 5 >= lastSave) {
                save()
            }
        }, 1000)
    })

    function timeFormat(seconds) {
        let hours = Math.floor(seconds / 60 / 60)
        let minutes = Math.floor((seconds - hours * 60 * 60) / 60)
        let secs = seconds - (hours * 60 * 60) - (minutes * 60)
        return `${hours}:${minutes<10?"0":""}${minutes}:${secs<10?"0":""}${secs}`
    }
</script>

<Tailwindcss />

<div class="min-h-screen w-full relative bg-slate-100">
    <header class="sticky top-0 left-0 right-0 w-full h-20 border-b border-slate-300 px-12 py-4 bg-white flex items-center justify-between">
        <img src="/logo.svg" alt="linu.us Logo" title="linu.us by Linus Benkner" class="h-full" />
        <div class="flex items-center gap-4">
            <a target="_blank" class="px-3 py-1 font-bold lowercase text-lg text-indigo-900 hover:bg-indigo-100 rounded" href="https://linu.us" title="Visit my blog">linu.us blog</a>
            <a target="_blank" class="px-3 py-1 font-bold lowercase text-lg text-indigo-900 hover:bg-indigo-100 rounded" href="https://twitter.com/EinLinuus" title="Follow me on Twitter">Twitter @EinLinuus</a>
        </div>
    </header>
    <main class="my-14 max-w-3xl mx-auto">
        {#each timers as timer, index}
            <div class="mb-6 bg-white rounded border-l-8 flex items-stretch overflow-hidden ring-indigo-50" class:ring-4={activeTimers.includes(index)} style={`border-color: ${timer.color}; --tw-ring-color: ${timer.color}`}>
                <div class="pt-4 pb-2 px-6 w-full">
                    <div class="flex items-center gap-4 mb-3">
                        <button on:click={() => swapColor(index)} class="w-5 h-5 rounded border-none shrink-0" style={`background-color: ${timer.color};`} title="Change color"></button>
                        <input type="text" placeholder="Name the timer" bind:value={timers[index].name} class="p-0 font-bold text-3xl block w-full border-none focus:outline-none focus:ring-1 ring-indigo-900/50" />
                    </div>
                    <div class="flex items-center gap-4">
                        {#if activeTimers.includes(index)}
                            <button title="Stop timer" on:click={() => stopTimer(index)} class="text-indigo-900 border-none">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H8z" clip-rule="evenodd" />
</svg>
                            </button>
                        {:else}
                            <button title="Start" on:click={() => startTimer(index)} class="text-indigo-900 border-none">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clip-rule="evenodd" />
</svg>
                            </button>
                        {/if}
                        <button title="Reset timer" on:click={() => resetTimer(index)} class="h-8 w-8 text-indigo-400 flex items-center justify-center rounded-full bg-indigo-100 border-none" disabled={activeTimers.includes(index)}>
                         <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
</svg>   
                        </button>
                        <button title="Delete timer" on:click={() => deleteTimer(index)} class="h-8 w-8 text-indigo-400 flex items-center justify-center rounded-full bg-indigo-100 border-none" disabled={activeTimers.includes(index)}>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
</svg>
                        </button>
                    </div>
                </div>
                <div class="shrink-0 text-white font-bold text-4xl px-4 flex items-center" style={`background-color: ${timer.color};`}>
                    <span class="tabular-nums">{timeFormat(timer.timer)}</span>
                </div>
            </div>
        {/each}
        <button on:click={addTimer} class="px-6 py-3 bg-indigo-900 font-bold text-white rounded hover:bg-indigo-800 active:translate-y-2 border-none active:bg-indigo-900">
            Add tracker
        </button>
    </main>
</div>

<style global>
    body {
        padding: 0;
    }
    a {
        @apply no-underline hover:no-underline;
    }
</style>
